<template>
    <div class="event-screen activity w-100 h-100 overflow-hidden d-flex flex-column">
        <div class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images?.activity_image}')`}"></div>
        <template v-if="$store.state.game.question">
            <div :class="'d-flex flex-column h-100 w-100' + ((title == true) ? ' d-none' : '')">
                <div class="d-flex align-items-center justify-content-between px-4 py-3 activity-topbar">
                    <div class="flex-fill me-3" style="min-width: 0">
                        <StageProgress v-if="progress" :types="progress.types" :index="progress.index" :completed="true" :color="own_jersey_color || undefined" />
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-light" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>
                </div>
                <div class="flex-fill overflow-auto p-4" id="question-bg">
                    <div v-if="$store.state.game.user.role == utils.USER_ROLES.PLAYER && own_result.answered && !utils.is_content_activity($store.state.game.question.question.type)" :class="'feedback-banner mb-4 ' + (own_result.correct ? 'feedback-correct' : 'feedback-incorrect')">
                        <i :class="'bi feedback-icon ' + (own_result.correct ? 'bi-check-circle-fill' : 'bi-x-circle-fill')"></i>
                        <div class="feedback-headline">{{ own_result.correct ? '¡Respuesta correcta!' : 'Respuesta incorrecta' }}</div>
                        <div class="feedback-detail" v-if="correct_answer_text">{{ correct_answer_text }}</div>
                        <div class="feedback-points" v-if="own_result.correct">+{{ Math.round(own_result.score) }} <small>puntos</small></div>
                    </div>
                    <div id="text-region" class="animate__animated animate__fadeInDown" v-html="format_title($store.state.game.question.question.title)"></div>
                    <FeedbackContent class="mt-4" :value="$store.state.game.question.question.feedback" />
                    <div id="question-body" class="w-100 mt-4">
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ || $store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ_MULTIPLE">
                            <quiz-act></quiz-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.CROSSWORD">
                            <cross-word-act></cross-word-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TEXT">
                            <text-act></text-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TRUE_FALSE">
                            <true-false-act></true-false-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.RANGE">
                            <range-act></range-act>
                        </template>
                    </div>
                </div>
                <div v-if="own_jersey_color" class="activity-jersey-card">
                    <div class="activity-jersey-card-label">Equipo</div>
                    <TeamJerseyBadge :color="own_jersey_color" :size="38" />
                    <div class="activity-jersey-card-name">{{ $store.state.game.user.username.toUpperCase() }}</div>
                </div>
                <div class="d-flex align-items-center justify-content-end px-4 py-2 activity-footer">
                    <EventBrand />
                </div>
            </div>
            <div v-if="title == true" class="position-absolute top-0 start-0 w-100 h-100 p-1 title-modal-bg">
                <div  class="row m-0 h-100 d-flex justify-content-center align-items-center animate__animated animate__fadeInDown">
                    <div class="d-flex justify-content-center align-items-center flex-column">
                        <span id="title-text-modal" class="text-center">{{ $store.state.game.question.question.title }}</span>
                        <div v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.CROSSWORD" class="col-8">
                            <p class="title-choice text-white" v-for="(choice, idx) in $store.state.game.question.question.choices">{{ idx+1 }}.- {{ choice }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="modal fade p-3" id="previewImageModal" tabindex="-1" aria-labelledby="previewImageModal" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen w-100 h-100">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5 text-black" id="previewImageModal">Imagen</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body bg-dark bg-opacity-25 w-100 h-100 d-flex justify-content-center align-items-center">
                        <div class="w-100 h-100 d-flex justify-content-center align-items-start">
                            <img class="img-fluid" :src="preview_img">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBrand from '@/components/EventBrand.vue'
import FeedbackContent from '@/components/FeedbackContent.vue';
import QuizAct from '@/components/type/Quiz.vue';
import CrossWordAct from '@/components/type/CrossWord.vue';
import TextAct from '@/components/type/Text.vue';
import TrueFalseAct from '@/components/type/TrueFalse.vue';
import RangeAct from '@/components/type/Range.vue';
import TeamJerseyBadge from '@/components/TeamJerseyBadge.vue'
import StageProgress from '@/components/StageProgress.vue'
import { stageProgress } from '@/utils/stage-progress'

export default {
    name: 'Result',
    components: {
        EventBrand,
        FeedbackContent,
        QuizAct,
        CrossWordAct,
        TextAct,
        TrueFalseAct,
        RangeAct,
        TeamJerseyBadge,
        StageProgress
    },
    data(){
        return {
            utils: require('../../../shared/utils'),
            title: false,
            preview_img: null,
            img_preview: false,
        };
    },
    computed : {
        // Where we are in the current stage - see utils/stage-progress.js.
        progress(){
            return stageProgress(this.$store.state.game);
        },
        own_jersey_color(){
            const user = this.$store.state.game.user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        },
        own_result(){
            var question = this.$store.state.game.question;
            if(!question) return { answered: false, correct: false, score: 0 };
            return this.utils.calc_question_result(this.$store.state.game.user.data, question.question.id);
        },
        correct_answer_text(){
            var question = this.$store.state.game.question;
            if(!question) return null;
            var q = question.question;
            var correctAnswer = q.correctAnswer || [];
            if(q.type == this.utils.ACTIVITY_TYPE.TEXT || q.type == this.utils.ACTIVITY_TYPE.RANGE)
                return correctAnswer[0] || null;
            if(q.choices && correctAnswer.length > 0)
                return correctAnswer.map((idx) => q.choices[idx]).join(', ');
            return null;
        }
    },
    mounted(){
        if(window.store.state.network == "connected")
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))

        $('.modal-backdrop').remove();
    },
    methods:{
        logout(){
            this.utils.reset_client();
        },
        toggle_imgpreview(){
            this.img_preview = !this.img_preview;
        },
        format_title(title){
            // Expresión regular para encontrar enlaces en el texto
            const regex = /https?:\/\/[^\s]+/g;

            // Reemplazar enlaces en el texto con botones
            const textoConBoton = title.replace(regex, (match) => {
                this.preview_img = match;
                return `<button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#previewImageModal">ver imagen</button>`;
            });

            $('#preview-img').click(function(){
                this.toggle_imgpreview();
            }.bind(this));

            return textoConBoton;
        },
    }
}
</script>

<style scoped>
    .activity{
        background-color: var(--vc-paper-200);
    }

    .activity-topbar{
        background-color: var(--vc-ink-900);
        flex-shrink: 0;
    }


    .activity-footer{
        background-color: var(--vc-paper-50);
        border-top: 1px solid var(--vc-line);
        flex-shrink: 0;
    }

    /* Same floating-card idea as Activity.vue's countdown timer, mirrored to
       the bottom edge: sits between the question area and the footer, pulled
       down with a negative bottom margin so it overlaps the footer, pinned
       to the left. Holds "Equipo" / jersey / team name stacked, replacing
       the old plain footer text entirely. */
    .activity-jersey-card{
        position: relative;
        align-self: flex-start;
        margin-left: 24px;
        margin-bottom: -30px;
        z-index: 20;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 18px 14px;
        background-color: var(--vc-paper-50);
        border-radius: 16px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    }

    .activity-jersey-card-label{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.65rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: var(--vc-text-600);
        margin-bottom: 4px;
    }

    .activity-jersey-card-name{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 0.8rem;
        color: var(--vc-ink-900);
        margin-top: 4px;
        max-width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    #logos img{
        max-height: 32px;
    }

    #question-bg{
        border-radius: 0;
    }

    .animate__delay-0-5s
    {
        --animate-delay: 0.5s;
    }

    #title-text-modal{
        font-family: "Public Sans", sans-serif; font-weight: 700;
        font-size: 2.5vw !important;
        color: var(--vc-paper-50) !important;
    }

    .feedback-banner{
        text-align: center;
        padding: 28px;
        border-radius: 12px;
    }

    .feedback-icon{
        font-size: 3rem;
    }

    .feedback-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.6rem;
        text-transform: uppercase;
        margin-top: 8px;
    }

    .feedback-detail{
        color: var(--vc-text-600);
        margin-top: 4px;
    }

    .feedback-points{
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 2.2rem;
        margin-top: 12px;
    }
    .feedback-points small{
        font-family: "Public Sans", sans-serif;
        font-weight: 700;
        font-size: 0.9rem;
        text-transform: uppercase;
    }

    .feedback-correct{
        background-color: var(--vc-success-100);
    }
    .feedback-correct .feedback-icon,
    .feedback-correct .feedback-headline,
    .feedback-correct .feedback-points{
        color: var(--vc-success-500);
    }

    .feedback-incorrect{
        background-color: var(--vc-danger-100);
    }
    .feedback-incorrect .feedback-icon,
    .feedback-incorrect .feedback-headline{
        color: var(--vc-danger-500);
    }
</style>
